import makeStyles from "@material-ui/core/styles/makeStyles";

export default makeStyles(() => ({
  root: {
    overflow: "visible",
    height: 0,
    width: 0
  },
  container: {
    position: "relative",
    overflow: "auto",
    willChange: "transform",
    direction: "ltr"
  },
  item: {
    position: "absolute",
    left: 0,
    width: "auto"
  }
}));
